import config from 'app-self-support-order/config'

const crmThirdPartyShopApi = `${config.apiHost}/oem-crm_third_party_shop`

export default {
    getOrderList: {
        url: `${crmThirdPartyShopApi}/api/order/order-histories`,
        type: 'GET',
    },
    getFailedOrderlist: {
        url: `${crmThirdPartyShopApi}/api/order/order-histories/{id}/failed_history`,
        type: 'GET',
    },
    editRemark: {
        url: `${crmThirdPartyShopApi}/api/order/order-histories/{id}`,
        type: 'PUT',
    },
    // 手动导入订单
    importOrderByManual: {
        url: `${crmThirdPartyShopApi}/api/order/order-histories`,
        type: 'POST',
    },
    // 获取API订单接入-设置
    getIpSetting: {
        url: `${crmThirdPartyShopApi}/api/config/import`,
        type: 'GET',
    },
    resetIpSetting: {
        url: `${crmThirdPartyShopApi}/api/config/import/secret/reset`,
        type: 'PUT',
    },
    setIpSetting: {
        url: `${crmThirdPartyShopApi}/api/config/import`,
        type: 'PUT',
    },
}
